import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';

export const getSingleProductFunc = createAsyncThunk(
  "getSingleProduct",
  async (id, thunkAPI) => {
    try {
      const response = await api.get(`dashboard/products/${id}`);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const getSingleProductSlicer = createSlice({
  name: "getSingleProduct",
  initialState: {
    loading: false,
    data: null,
    error: null,
    apiErrors: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSingleProductFunc.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.apiErrors = {};
      })
      .addCase(getSingleProductFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getSingleProductFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  },
});

export default getSingleProductSlicer.reducer;
